export const INTERNAL_ANALYTICS_KEY = "yoshinani.analytics.internal"
export const ANALYTICS_HOSTS = ["yoshinani.co.jp", "www.yoshinani.co.jp"]
export type AnalyticsMode = "external" | "internal" | "preview"

declare global {
  interface Window {
    __yoshinaniAnalyticsMode?: AnalyticsMode
    __yoshinaniAnalyticsPersistent?: boolean
  }
}

export function getAnalyticsMode(): AnalyticsMode {
  if (typeof window === "undefined") return "preview"
  return (
    window.__yoshinaniAnalyticsMode ??
    (ANALYTICS_HOSTS.includes(window.location.hostname)
      ? "external"
      : "preview")
  )
}

/** 初回の自動page_viewより前に判定する。入力値・利用者の識別情報は扱わない。 */
export function analyticsBootstrap(gaId: string) {
  const id = JSON.stringify(gaId).replaceAll("<", "\\u003c")
  return `
(function(){
  var key = ${JSON.stringify(INTERNAL_ANALYTICS_KEY)};
  var command = new URLSearchParams(window.location.search).get('analytics');
  var internal = command === 'internal';
  var persistent = false;
  try {
    if (command === 'internal') window.localStorage.setItem(key, '1');
    if (command === 'reset') window.localStorage.removeItem(key);
    internal = command === 'internal' || window.localStorage.getItem(key) === '1';
    persistent = true;
  } catch (_) {}
  var production = ${JSON.stringify(ANALYTICS_HOSTS)}.includes(window.location.hostname);
  var mode = internal ? 'internal' : production ? 'external' : 'preview';
  window.__yoshinaniAnalyticsMode = mode;
  window.__yoshinaniAnalyticsPersistent = persistent;
  window['ga-disable-' + ${id}] = mode !== 'external';
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){ window.dataLayer.push(arguments); };
  if (mode !== 'external') return;
  window.gtag('consent','default',{
    ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied',
    analytics_storage:'granted'
  });
  window.gtag('js', new Date());
  window.gtag('config', ${id});
})();
`
}
